







"use strict";

const httpUtil = require("common-util/browser/http-util.js");
const XuxTableSupport = require("common-util/browser/xux-table-support.js");
const {WebStorageManager} = require("common-util/browser/webstorage-util.js");
const storage = new WebStorageManager();
const Util = require("./util");
const util = new Util();

$.orderReloadFlag = false;
$.redirectUrl = undefined;
const ORDER_PAGE_SIZE = 300;
const ORDER_FILTER_STRING = {
    FINISHED_ORDER: "closed:true",
    UNFINISHED_ORDER: "closed:false,null"
};

const ORDER_TAB_INDEX = {
    UNFINISHED: 0,
    FINISHED: 1
};







function checkSelection(enable) {
    let selection = $("#order-tabs .list-table:visible table").xuxTable("selection");
    let isEnable = (typeof enable === "boolean") ? enable : (selection.length > 0);
    let status = isEnable ? "enable" : "disable";

    $("#order-edit:visible").xuxButton(status);
    $("#order-delete:visible").xuxButton(status);

    $("#order-operation").xuxButton(status);
}









function initXuxTable(app, elemTable, filter) {
    $.orderNextId = [];
    let tableSupport = new XuxTableSupport({
        elem: elemTable,
        l10n: app.l10n,
        columns: {
            orderId: {
                _localizationLabel: "order.label.orderNum",
                contentEllipsis: true,
                defaultSortOrder: "asc"
            },
            createdAt: {
                _localizationLabel: "order.label.createDate",
                _defaultSort: true,
                contentEllipsis: true,
                defaultSortOrder: "desc",
                _sortByBeforeFormat: true,
                _formatter(value) {
                    return $.xux.formatDateTime(util.getDate(value),
                                                {seconds: true});
                }
            },
            orderComment: {
                _localizationLabel: "order.label.orderMemo",
                contentEllipsis: true,
                defaultSortOrder: "asc"
            }
        },
        supportOptions: {
            enableBrowserfilter: true,
            cachePagingMethod: "unindexed",
            itemsPerPage: ORDER_PAGE_SIZE,
            maxLoadedCacheSize: 1,
            xuxPagesPerLoad: 1,
            fetch(_fetchOption, xuxOptions) {
                checkSelection(false);
                let pageNum = xuxOptions.start / ORDER_PAGE_SIZE;
                let url = tableSupport.createQueryUrl(
                    httpUtil.getApiUrl("/p2p/orders") + "?timestamp=" + Date.now());
                return app.ajaxAuth({
                    url,
                    type: "get",
                    contentType: "application/json",
                    data: {
                        fromId: $.orderNextId[pageNum - 1],
                        max: ORDER_PAGE_SIZE,
                        filter
                    },
                    success(data) {
                        $.orderNextId[pageNum] = JSON.stringify(data.nextId);
                    }
                });
            }
        },
        xuxOptions: {
            selectionUnit: "row",
            selectionControl: "radio",
            selectionRemains: true,
            itemId: "orderId",
            pageNumbers: false,
            xuxPageCacheRate: 1,
            columnResizable: true,
            sortOptions: {
                column: 2,
                order: "desc"
            },
            autoLoad: false,
            pageNavigation: "both",
            select: checkSelection,
            unselect: checkSelection,
            afterRender: checkSelection
        }
    });

    tableSupport.init();
}





function initTabs(app) {
    $("#order-tabs").xuxTabbedSet({
        active: (app.session.isOrderManager && storage.getItem("orderFinished") === "true")
                ? ORDER_TAB_INDEX.FINISHED : ORDER_TAB_INDEX.UNFINISHED,
        activate(event, ui) {
            ui.newPanel.find(".list-table:visible").xuxDecoratedTable("reload");
            setOperationButtonText();
        },
        disabled: app.session.isOrderManager ? [] : [ORDER_TAB_INDEX.FINISHED]
    });

    if (!app.session.isOrderManager) {
        const tab2 = $("#order-tabs").find("ul li").eq(ORDER_TAB_INDEX.FINISHED);
        tab2.attr("title", window.localizedTextMessages.order.notice.finishedOrderTips);
        tab2.xuxTooltip({disabled: true});
        tab2.css("pointer-events", "auto");
    }
}




function setOperationButtonText() {
    const activeTabIndex = $("#order-tabs").xuxTabbedSet("option", "active");
    let buttonText;
    if (activeTabIndex === ORDER_TAB_INDEX.UNFINISHED) {
        buttonText = window.localizedTextMessages.order.btn.select;
    } else {
        buttonText = window.localizedTextMessages.order.btn.browse;
    }
    $("#order-operation").find(".xux-button-text").text(buttonText);
}

function openOrderList(app, page) {
    let orderModalWindow = util.patchModalWindow("#order-modalWindow");
    let orderListTable = $("#unfinishedOrder-table");
    let finishedOrderListTable = $("#finishedOrder-table");
    let buttonCancel = $("#order-operation-cancel");
    let buttonRegister = $("#order-register");

    if ($.orderReloadFlag) {
        orderModalWindow.xuxModalWindow("open");
    } else {
        initTabs(app);
        initXuxTable(app, orderListTable, ORDER_FILTER_STRING.UNFINISHED_ORDER);
        initXuxTable(app, finishedOrderListTable, ORDER_FILTER_STRING.FINISHED_ORDER);
        orderModalWindow.xuxModalWindow({
            leadingMargin: false,
            type: "settings",
            width: "wide",
            height: "fit",
            autoOpen: true,
            open() {
                buttonCancel[$("#orderId").length === 0 ? "hide" : "show"]();
                $("#order-tabs .list-table:visible").xuxDecoratedTable("reload");

                setOperationButtonText();

                $("#order-operation").unbind("click").click(() => {
                    let activeTabIndex = $("#order-tabs").xuxTabbedSet("option", "active");
                    let orderFinished = (activeTabIndex === ORDER_TAB_INDEX.FINISHED);
                    const selection = $("#order-tabs .list-table:visible table").xuxTable("selection");

                    let orderId = selection.find("td:eq(1)").text();
                    let orderMemo = selection.find("td:eq(3)").text();
                    let settedOrderMemo = orderMemo;
                    storage.setItem("orderId", orderId);
                    storage.setItem("orderComment", orderMemo);
                    storage.setItem("orderFinished", orderFinished);
                    orderModalWindow.xuxModalWindow("close");
                    if (page) {
                        $("#" + page).show();
                    }
                    $("#orderId").html(util.text(orderId));
                    $("#orderComment").html(util.text(settedOrderMemo));
                    $("#orderComment").prop("title", settedOrderMemo);
                    $(".list-table:visible").not("#order-tabs .list-table:visible")
                        .xuxDecoratedTable("reload");
                });

                $("#order-info").xuxApplyBoxAndLayout();
                $("#order-operation-cancel").unbind("click").click(() => {
                    orderModalWindow.xuxModalWindow("close");
                });

                $("#register-order-cancel").unbind("click").click(() => {
                    util.modalWindow("#register-order-modalWindow", "close");
                });

                $("#edit-order-cancel").unbind("click").click(() => {
                    let form = $("#edit-order-modalWindow").find("form");
                    form[0].reset();
                    util.modalWindow("#edit-order-modalWindow", "close");
                });

                buttonRegister.unbind("click").click(() => {
                    let registerOrderModalWindow = $("#register-order-modalWindow");
                    $("#memoTextarea").xuxTextArea().prop("placeholder", window.localizedTextMessages.order.notice.placeholder);
                    util.modalWindow(registerOrderModalWindow, {
                        leadingMargin: false,
                        type: "settings",
                        width: "normal",
                        height: "auto",
                        autoOpen: true,
                        open() {
                            $("#register-order").unbind("click").click(() => {
                                lockUnlockForSubmit("register", true);
                                if ($("#register-order-modalWindow").find("form").xuxValidate("valid")) {
                                    doRegisterOrder(app, $("#memoTextarea").val());
                                }
                            });
                            $("#register-order").xuxButton("disable");
                            $("#memoTextarea").keyup(() => {
                                if ($("#memoTextarea").val()) {
                                    $("#register-order").xuxButton("enable");
                                } else {
                                    $("#register-order").xuxButton("disable");
                                }
                            });
                        }
                    });

                    registerOrderModalWindow.find("form").xuxValidate();
                    registerOrderModalWindow.find("form")[0].reset();
                });

                buttonRegister.xuxButton(app.session.isOrderManager ? "enable" : "disable");

                $("#order-edit").unbind("click").click(() => {
                    let editOrderModalWindow = $("#edit-order-modalWindow");
                    $("#memoEditTextarea").xuxTextArea().prop("placeholder", window.localizedTextMessages.order.notice.placeholder);
                    let selection = $("#order-list-table").xuxTable("selection");
                    let orderId = selection.find("td:eq(1)").text();
                    let memo;
                    app.ajaxAuth({
                        url: httpUtil.getApiUrl("/p2p/orders/" + orderId + "?timestamp=" + Date.now()),
                        type: "get",
                        contentType: "application/json"
                    }).then(result => {
                        memo = result.orderComment;
                        $("#memoEditTextarea").val(memo);
                        $("#orderIdLabel").text(orderId);
                        editOrderModalWindow.find("form").xuxValidate();
                        util.modalWindow(editOrderModalWindow, {
                            leadingMargin: false,
                            type: "settings",
                            width: "normal",
                            height: "auto",
                            autoOpen: true,
                            open() {
                                $("#edit-order").unbind("click").click(() => {
                                    lockUnlockForSubmit("edit", true);
                                    if (editOrderModalWindow.find("form").xuxValidate("valid")) {
                                        doEditOrder(app, orderId, $("#memoEditTextarea").val());
                                    }
                                });

                                $("#edit-order").xuxButton("enable");
                                $("#memoEditTextarea").keyup(() => {
                                    if ($("#memoEditTextarea").val()) {
                                        $("#edit-order").xuxButton("enable");
                                    } else {
                                        $("#edit-order").xuxButton("disable");
                                    }
                                });
                            }
                        });
                    });
                });

                $("#order-delete").unbind("click").click(() => {
                    let selection = $("#order-list-table").xuxTable("selection");
                    let orderId = selection.find("td:eq(1)").text();
                    let orderMemo = selection.find("td:eq(3)").text();
                    let title = window.localizedTextMessages.order.title.terminateOrder;
                    let message = window.localizedTextMessages.order.warn.terminateOrder;
                    util.messageAlertTable({
                        title,
                        message,
                        data: [{id: orderId, memo: orderMemo}],
                        thead: ["order.label.orderNum", "order.label.orderMemo"],
                        yesBtnMsg: window.localizedTextMessages.order.btn.terminate,
                        tbody(data) {
                            let tr = "<tr><td>" + util.text(data.id) + "</td><td><div>" + util.text(data.memo) + "</div></td></tr>";
                            return tr;
                        },
                        yes() {
                            doDeleteOrder(app, orderId);
                        }
                    });
                });
                checkSelection(false);
            },
            close() {
                orderListTable.xuxDecoratedTable("clearSearch");
                finishedOrderListTable.xuxDecoratedTable("clearSearch");
                orderListTable.xuxDecoratedTable("resetAllSelections");
                finishedOrderListTable.xuxDecoratedTable("resetAllSelections");
                $.orderReloadFlag = true;
            }
        });
    }

    buttonCancel.xuxButton((page ? "disable" : "enable"));
    orderModalWindow.xuxModalWindow("option", "closeOnEscape", !page);
}

function doDeleteOrder(app, orderId) {
    return app.ajaxAuth({
        url: httpUtil.getApiUrl("/p2p/orders/" + orderId),
        type: "post",
        contentType: "application/json",
        data: JSON.stringify({
            action: "close"
        })
    }).then(() => {
        
        
        if (orderId === storage.getItem("orderId")) {
            $("#order-operation-cancel").xuxButton("disable");
        }
        $("#unfinishedOrder-table").xuxDecoratedTable("load", {firstData: false,
                                                               noCache: true});
        checkSelection(false);
    });
}

function doEditOrder(app, orderId, memo) {
    return app.ajaxAuth({
        url: httpUtil.getApiUrl("/p2p/orders/" + orderId),
        type: "post",
        contentType: "application/json",
        data: JSON.stringify({
            action: "updateComment",
            orderComment: memo
        })
    }).then(() => {
        util.modalWindow("#edit-order-modalWindow", "close");
        $("#unfinishedOrder-table").xuxDecoratedTable("load", {firstData: false,
                                                               noCache: true});
        checkSelection(false);
    }).finally(() => {
        lockUnlockForSubmit("edit", false);
    });
}

function doRegisterOrder(app, memo) {
    return app.ajaxAuth({
        url: httpUtil.getApiUrl("/p2p/orders"),
        type: "post",
        contentType: "application/json",
        data: JSON.stringify({
            orderComment: memo
        })
    }).then(() => {
        util.modalWindow("#register-order-modalWindow", "close");
        $("#unfinishedOrder-table").xuxDecoratedTable("reload");
        checkSelection(false);
    }).finally(() => {
        lockUnlockForSubmit("register", false);
    });
}

function lockUnlockForSubmit(operation, isLock) {
    let xuxAction = isLock ? "disable" : "enable";
    let okButton, cancelButton, memoTextArea;
    if (operation === "register") {
        okButton = $("#register-order");
        cancelButton = $("#register-order-cancel");
        memoTextArea = $("#memoTextarea");
    } else {
        okButton = $("#edit-order");
        cancelButton = $("#edit-order-cancel");
        memoTextArea = $("#memoEditTextarea");
    }
    okButton.xuxButton(xuxAction);
    cancelButton.xuxButton(xuxAction);
    memoTextArea.xuxTextArea(xuxAction);
}

module.exports = {
    openOrderList
};
